module.exports = __webpack_public_path__ + "static/mono-54-f012c12fdc0a7ca121c5cfe960503ef3.png";